<template>
  <div class="c-summary__group">
    <label class="c-summary__label">{{ label }}:</label>

    <span v-if="!isHidden" class="c-summary__value">{{ value }}</span>

    <div class="c-summary__value" v-if="isHidden">
      <span v-for="index in value?.length" :key="index">•</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string
  value?: string
  isHidden?: boolean
}>()
</script>
